export default {
  workingdays: [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
  ],
};
